import React, { useState } from 'react';
import { Tabs, Card } from 'antd';
import FarmerMappingList from '../components/FarmerMappings/FarmerMappingList';
import BulkMappingCreate from '../components/FarmerMappings/BulkMappingCreate';

const { TabPane } = Tabs;

const FarmerMappings = () => {
    const [activeTab, setActiveTab] = useState('1');
    const [refreshKey, setRefreshKey] = useState(0);

    const handleBulkCreateSuccess = () => {
        setRefreshKey(prev => prev + 1);
        setActiveTab('1');
    };

    return (
        <Card title="Farmer-Company Mappings">
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane tab="Mappings List" key="1">
                    <FarmerMappingList key={refreshKey} />
                </TabPane>
                <TabPane tab="Bulk Create" key="2">
                    <BulkMappingCreate onSuccess={handleBulkCreateSuccess} />
                </TabPane>
            </Tabs>
        </Card>
    );
};

export default FarmerMappings; 